
import Store from '../store/Store'

export default class {

    static setPageData(name, value) {
        Store.commit('setPageData', {name, value})
    }

    static getPageData(name) {
        return Store.getters.getPageData(name)
    }

    static clearPageData() {
        Store.commit('clearPageData')
    }
        
}


// WEBPACK FOOTER //
// ./src/helpers/PageHelpers.js